import { supabase } from "../supabaseClient";
import { compareSeasonsDesc } from "./leagueCatalog";

/**
 * Public data for one official team (`teams.id`): the team row, the league it plays in
 * (newest season it has fixtures for), that league's fixtures and the team's players.
 * Resolves to `{ team: null }` when the team doesn't exist.
 */
export async function fetchTeamLeagueData(teamId) {
  const { data: team, error: teamErr } = await supabase
    .from("teams")
    .select("id, name, logo_url, city, division, sport, age_group")
    .eq("id", teamId)
    .maybeSingle();
  if (teamErr || !team) return { team: null };

  const { data: own } = await supabase
    .from("fixtures")
    .select("city, division, sport, age_group, season")
    .or(`home_team_id.eq.${team.id},away_team_id.eq.${team.id}`);
  const latest = [...(own || [])].sort((a, b) => compareSeasonsDesc(a.season, b.season))[0];
  const league = latest || { city: team.city, division: team.division, sport: team.sport, age_group: team.age_group, season: null };

  let fq = supabase
    .from("fixtures")
    .select(
      "id, date, time, field, season, home_team_id, away_team_id, home_team_score, away_team_score, is_forfeit, home_team:home_team_id (name, logo_url), away_team:away_team_id (name, logo_url)"
    )
    .eq("city", league.city)
    .eq("sport", league.sport)
    .ilike("division", league.division || "")
    .order("date", { ascending: true });
  if (league.age_group) fq = fq.eq("age_group", league.age_group);
  if (league.season) fq = fq.eq("season", league.season);

  const [{ data: fixtures }, { data: players }] = await Promise.all([
    latest ? fq : Promise.resolve({ data: [] }),
    supabase.from("players").select("id, name, jersey_number, goals, assists, red_cards").eq("team_id", team.id),
  ]);
  return { team, league, fixtures: fixtures || [], players: players || [] };
}

export const leagueQueryString = (league) =>
  new URLSearchParams({
    city: league.city,
    division: league.division,
    ...(league.season ? { season: league.season } : {}),
  }).toString();
